import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgFormatSuperscript = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M8 4.75H4.75a1 1 0 0 0-1 1v2m4.25-3h3.25a1 1 0 0 1 1 1v2M8 4.75v10.5m0 0H5.75m2.25 0h2.25m8-8.5h-3.5s2.75-2 3-3-.25-2-1.5-2-1.5 1-1.5 1.25"
	})]
});
const ForwardRef = forwardRef(SvgFormatSuperscript);
export { ForwardRef as ReactComponent };
